<template>
  <div v-if="showSelector" class="mb-4">
    <label :for="setting.id">
      {{ setting.label }}
    </label>

    <SettingsMessage v-if="setting.message" :message="setting.message" />

    <Selector
      :name="setting.id"
      :options="setting.items"
      :value="selectedItem"
      :disabled="saving"
      :clearable="false"
      @input="onInput"
    />
  </div>
</template>

<script>
import clone from "just-clone";

import Selector from "@/components/UI/Selector";
import SettingsMessage from "./SettingsMessage";

export default {
  name: "SelectorSetting",
  components: {
    Selector,
    SettingsMessage,
  },
  props: {
    setting: {
      type: Object,
      required: true,
      id: {
        required: true,
        type: String,
      },
      label: {
        required: true,
        type: String,
      },
      items: {
        required: false,
        type: Array,
      },
      selectorValue: {
        default: "",
        type: String,
      },
    },
    saving: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    selectedItem() {
      const items = this.setting?.items ?? [];

      const selected = items.filter(
        (item) => item.value === this.setting.selectorValue
      );
      // TODO: FIX THIS BUG - CHECK IN HERO SECTION
      // TODO: Background Image Exposure not showing in ui because of this
      return selected.length
        ? {
            label: selected[0].label,
            value: selected[0].value,
          }
        : {};
    },
    showSelector() {
      return this.setting?.items && this.setting?.items.length;
    },
  },
  methods: {
    onInput(event) {
      const setting = clone(this.setting);
      setting.selectorValue = this.$has(event, "value") ? event.value : null;
      this.$emit("setting-updated", setting, event.value);
    },
  },
};
</script>

<style scoped></style>
